import React, { useState, useEffect, useCallback } from "react";
import ReactPlayer from "react-player";

import {
  Accordion,
  AccordionActions,
  AccordionSummary,
  Box,
  Button,
  Grid,
  Tooltip,
  Slider,
  AccordionDetails,
  CircularProgress,
  Alert,
} from "@mui/material";
import { useSelector } from "react-redux";
import { videoTimeStampLocation } from "../constants/control";
import LoaderVideo from "./LoaderVideo";
import AltVideoCard from "./AltVideoCard";
import PlayCircleOutlineIcon from "@mui/icons-material/PlayCircleOutline";
import PauseCircleOutlineIcon from "@mui/icons-material/PauseCircleOutline";
import VolumeMuteOutlinedIcon from "@mui/icons-material/VolumeMuteOutlined";
import VolumeOffOutlinedIcon from "@mui/icons-material/VolumeOffOutlined";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import ExpandLessOutlinedIcon from "@mui/icons-material/ExpandLessOutlined";
import ExpandMoreOutlinedIcon from "@mui/icons-material/ExpandMoreOutlined";
import CameraRollIcon from "@mui/icons-material/CameraRoll";
import ManageSearchIcon from "@mui/icons-material/ManageSearch";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import SubtitlesIcon from "@mui/icons-material/Subtitles";
import SubtitlesOffIcon from "@mui/icons-material/SubtitlesOff";
import SwapHorizontalCircleOutlinedIcon from "@mui/icons-material/SwapHorizontalCircleOutlined";

import { useInView } from "react-intersection-observer";

import moment from "moment";
import {
  LibraryAddCheck,
  LocationOnOutlined,
  VerticalAlignBottom,
} from "@mui/icons-material";
import { userEventsURL } from "../constants/urls";
import axios from "axios";
import { generateDebugDrawerContent } from "./Messages";
import { S3Client, GetObjectCommand } from "@aws-sdk/client-s3";
import { fromCognitoIdentityPool } from "@aws-sdk/credential-provider-cognito-identity";
import { getSignedUrl } from "@aws-sdk/s3-request-presigner";

export default function VideoCard(props) {
  const mode = sessionStorage.getItem("mode");
  const devToolAccess = sessionStorage.getItem("devtools");
  const queryTextRedux = useSelector((state) => state.queryText.value);

  const [videos, setVideos] = useState(props.compilation);
  const [videoUrls, setVideoUrls] = useState([]);
  const [index, setIndex] = useState(null);

  const { ref, inView, entry } = useInView({
    /* Options */
    threshold: 0,
    rootMargin: "-20% 0% -20% 0%",
  });

  const [currentIndex, setCurrentIndex] = useState(0);
  const [currentVideo, setCurrentVideo] = useState(0);
  const [theme, setTheme] = useState("light");
  const [playing, setPlaying] = useState(true);
  const [playerClassName, setPlayerClassName] = useState(
    "react-player no-fade"
  );
  const [playedTime, setPlayedTime] = useState(0);
  const [wrapperClassName, setWrapperClassName] = useState("player-wrapper");
  const [narrative, setNarrative] = useState([]);
  const [fullNarrativeShown, setFullNarrativeShown] = useState(true);
  const [clipInterval, setClipInterval] = useState([]);
  const currentThreadID = useSelector((state) => state.activeChatID.value);
  const [fullNarrative, setFullNarrative] = useState(true);
  const toggleFullNarrative = () => {
    setFullNarrative(!fullNarrative);
  };

  const nextVideo = () => {
    if (currentIndex + 1 < videos.length) {
      // below is current state
      setCurrentVideo(videos[currentIndex + 1]);
      setCurrentIndex(currentIndex + 1);
    } else {
      setPlaying(false);
      setCurrentIndex(0);
      setCurrentVideo(0);
      setPlayedTime(0);
      setCurrentTime(0);
      playerref.current.seekTo(videos[0].video_start_time / 1000);
    }
  };

  const swapVideoClip = (index, altIndex, clipInterval) => {
    var tmp = [...videos[index]?.alternate_clips]; // Copy alternate clips array
    tmp[altIndex] = videos[index];
    var tmp_caption = videos[index].caption;

    videos[index] = videos[index]?.alternate_clips[altIndex];
    videos[index].alternate_clips = tmp;
    videos[index].caption = tmp_caption;

    if (videos[index]["id"] == clipInterval[0]) {
      videos[index].media_start_time = clipInterval[1][0];
      videos[index].media_end_time = clipInterval[1][1];
      videos[index].video_end_time = clipInterval[1][1] * 1000;
      videos[index].video_start_time = clipInterval[1][0] * 1000;
      videos[index].clip_duration = clipInterval[1][1] - clipInterval[1][0];
    }

    fetchSignedVideoUrls(videos[index]).then((newUrl) => {
      setVideoUrls((prevUrls) => {
        const updatedUrls = [...prevUrls];
        updatedUrls[index] = newUrl;
        return updatedUrls;
      });
    });

    setVideos([...videos]);
    props.open_alt_clips_panel(false);
    setCurrentVideo(videos[index]);

    let getCompilationDuration = 0;
    if (videos.length > 0) {
      let narr = [];
      videos.forEach((video) => {
        if (video.video_end_time) {
          // console.log("duration: ", video.media_end_time - video.media_start_time)
          getCompilationDuration +=
            (video.video_end_time - video.video_start_time) / 1000;
          narr.push(video.caption + " ");
        }
      });
      setNarrative(narr);
    }
  };

  const editCurrentClip = (index, clipInterval) => {
    if (videos[index].id == clipInterval[0]) {
      videos[index].media_start_time = clipInterval[1][0];
      videos[index].media_end_time = clipInterval[1][1];
      videos[index].video_end_time = clipInterval[1][1] * 1000;
      videos[index].video_start_time = clipInterval[1][0] * 1000;
      videos[index].clip_duration = clipInterval[1][1] - clipInterval[1][0];
    }
    setVideos(videos);
    props.open_alt_clips_panel(false);
    setCurrentVideo(videos[index]);
    let getCompilationDuration = 0;
    if (videos.length > 0) {
      let narr = [];
      videos.forEach((video) => {
        if (video.video_end_time) {
          // console.log("duration: ", video.media_end_time - video.media_start_time)
          getCompilationDuration +=
            (video.video_end_time - video.video_start_time) / 1000;
          narr.push(video.caption);
        }
      });
      setNarrative(narr);
    }
    // call rest endpoint to update the clip
    // const response = axios.post(
    //   userEventsURL,
    //   {
    //     action: 'clip_interval_change',
    //     chatId: currentThreadID,
    //     userId: sessionStorage.getItem('username'),
    //     clipId: videos[index].clip_id,
    //     newStartTime: parseFloat(clipInterval[1][0]) * 1000,
    //     newEndTime: parseFloat(clipInterval[1][1]) * 1000,
    //   },
    //   {
    //     headers: {
    //       Authorization: 'Basic ' + sessionStorage.getItem('idToken'),
    //       'Content-Type': 'application/json',
    //     },
    //   },
    // );
  };

  const handleInterval = (id, interval) => {

    let intervalArr = [];
    intervalArr.push(id);
    intervalArr.push(interval);
    setClipInterval(intervalArr);
  };
  const generateAltClipsDrawer = () => {
    // console.log('videos: ', videos)
    return (
      <Box p={4}>
        <div
          style={{
            border: "1px solid #AC1FFF",
            padding: 24,
            marginTop: 36,
            borderRadius: 12,
          }}
        >
          <p className="alt-clips-headertag">Current Clip</p>
          <div>
            {/* <p
              className="alt-clip"
              style={{
                fontFamily: "Roboto Condensed",
                fontSize: 20,
                fontWeight: 600,
                color: "#000000de",
                marginTop: 18,
              }}
            >
              {videos[currentIndex]?.program_name}
            </p> */}
            <AltVideoCard altVideo={videos[currentIndex]} handleInterval={handleInterval} />
            <Button
              size="medium"
              variant="contained"
              onClick={() => editCurrentClip(currentIndex, clipInterval)}
              startIcon={<SwapHorizontalCircleOutlinedIcon />}
              sx={{
                '&:hover': {
                  background: '#AC1FFF',
                  color: '#FFFFFF',
                },
                borderRadius: 12,
                fontSize: 13,
                fontWeight: 700,
                letterSpacing: '-0.5px',
                boxShadow: 0,
                marginTop: 2,
                marginLeft: 32,
                background: '#AC1FFF',
                color: '#FFFFFF',
                textTransform: 'capitalize',
              }}
            >
              Save Edit
            </Button>
            {/*
            <p className='alt-clip-metadata'>
            <CalendarMonthIcon sx={{verticalAlign: 'middle', fontSize: 18}}/> {videos[currentIndex].first_pub_date}
            <TimerOutlinedIcon sx={{verticalAlign: 'middle', fontSize: 18, ml: 4}}/> {Math.floor(videos[currentIndex].clip_duration / 60)}:{Math.floor(videos[currentIndex].clip_duration % 60) < 10 ? '0' : ''}{Math.floor(videos[currentIndex].clip_duration % 60)}</p>
            <p className='alt-clip-body'>{videos[currentIndex].moment_summary}</p>
            <video className='alt-clip' controls style={{borderRadius: 12}}><source src={`${videos[currentIndex].video_s3_presigned_url}#t=${parseFloat(videos[currentIndex].video_start_time) / 1000},${parseFloat(videos[currentIndex].video_end_time) / 1000}`}></source></video> */}
          </div>
        </div>
        {videos[currentIndex]?.alternate_clips &&
        videos[currentIndex]?.alternate_clips.length > 0 ? (
          <div
            style={{
              border: "1px solid #cccccc",
              padding: 12,
              marginTop: 36,
              borderRadius: 12,
            }}
          >
            <p className="alt-clips-headertag2">
              <b>Replacements for Clip {currentIndex + 1} </b>
            </p>
            {videos[currentIndex]?.alternate_clips.map((clip, index) => (
              <Accordion
                // defaultExpanded
                sx={{ mb: 2, mt: 2 }}
                elevation={0}
              >
                <AccordionSummary
                  style={{
                    fontFamily: "Roboto Condensed",
                    fontSize: 20,
                    fontWeight: 600,
                  }}
                  sx={{
                    margin: "12px 0 0",
                    "& .Mui-expanded": {
                      margin: "12px 0 0",
                    },
                  }}
                  expandIcon={<ExpandMoreIcon />}
                >
                  {index + 1}. {clip.moment_summary}
                </AccordionSummary>
                <AccordionDetails>
                  <AltVideoCard
                    altVideo={clip}
                    handleInterval={handleInterval}
                  />
                </AccordionDetails>
                <AccordionActions>
                  <Button
                    size="medium"
                    variant="contained"
                    style={{ justifyContent: "flex-start" }}
                    onClick={() =>
                      swapVideoClip(currentIndex, index, clipInterval)
                    }
                    startIcon={<SwapHorizontalCircleOutlinedIcon />}
                    sx={{
                      "&:hover": {
                        background: "#AC1FFF",
                        color: "#FFFFFF",
                      },
                      display: "flex",
                      borderRadius: 12,
                      fontSize: 13,
                      fontWeight: 700,
                      letterSpacing: "-0.5px",
                      boxShadow: 0,
                      marginBottom: 1,
                      background: "#AC1FFF",
                      color: "#FFFFFF",
                      textTransform: "capitalize",
                    }}
                  >
                    Swap & Use This Clip
                  </Button>
                </AccordionActions>
              </Accordion>
            ))}
          </div>
        ) : (
          <div>
            <p>No Alternate Clips</p>
          </div>
        )}
      </Box>
    );
  };

  let getCompilationDuration = 0;
  let marks = [];
  if (videos.length > 0) {
    videos.forEach((video) => {
      if (video.video_end_time) {
        // console.log("duration: ", video.media_end_time - video.media_start_time)
        getCompilationDuration +=
          (video.video_end_time - video.video_start_time) / 1000;
      }
    });
    let st_time = 0;
    videos.forEach((video) => {
      if (video.video_end_time) {
        st_time += (video.video_end_time - video.video_start_time) / 1000;
        marks.push({
          value: (st_time / getCompilationDuration) * 100,
          label: "",
        });
      }
    });
    marks.pop();
    props.alt_clips_drawer?.(generateAltClipsDrawer());
  }

  let timeSoFar = 0;
  const [currentTime, setCurrentTime] = useState(0);

  const playPauseHandler = () => {
    //plays and pause the video (toggling)
    setPlaying(!playing);
  };

  const altClipsClickHandler = () => {
    // stop video playing if it is
    setPlaying(false);
    props.open_alt_clips_panel(true);
  };

  const debugClickHandler = () => {
    // stop video playing if it is
    setPlaying(false);
    if (props.debug_messages && props.debug_messages.length > 0) {
      props.debug_drawer(generateDebugDrawerContent(props.debug_messages));
    }
    props.open_debug_panel(true);
  };

  const [captions, setCaptions] = useState(false);

  const captionHandler = () => {
    setCaptions(!captions);
  };

  const toggleFullNarrativeShown = () => {
    setFullNarrativeShown(!fullNarrativeShown);
  };

  const [mute, setMute] = useState(false);
  const muteHandler = () => {
    setMute(!mute);
  };

  const handlePager = (index) => {
    setCurrentIndex(index);
    setCurrentVideo(videos[index]);
    setPlayerClassName("react-player fade-in");
  };

  // the below regex extracts the soundbite language and speaker name and title
  const soundbite_regex = /\s*SOUNDBITE\s+\(([^\)]+)\):*\s+([^\:\|]+)[\:\|]+/;
  const soundbite_text = (text) => {
    if (!text) {
      return "true";
    }
    const match = text.match(soundbite_regex);
    // console.log('match: ', match)
    if (match) {
      if (match[1] !== "English") {
        return "true";
      } else {
        return match;
      }
    }
    return "true";
  };

  const sanitizeVideoCaption = (caption) => {
    if (!caption) {
      return "";
    }
    caption = caption.replace(/\s*\[ID:\s*\d+\]\s*/g, "");
    return caption.replace(/\s*\(ID:\s*\d+\)\s*/g, "");
  };

  // const fetchSignedVideoUrls = async (segments) => {
  //   let newURL = "";
  //   for (const segment of segments) {
  //     if (!segment.video_s3_bucket || !segment.video_s3_key) {
  //       newURL = "";
  //     } else {
  //       console.log("fetching Url")
  //       newURL = await fetchSignedVideoUrl(segment);
  //     }
  //   }
  //   setVideoUrls((prev) => [...prev, newURL]);
  // };

  // const fetchSignedVideoUrl = async (segment) => {
  //   return await generateSignedUrlForVideo(
  //     segment.video_s3_bucket,
  //     segment.video_s3_key
  //   );
  // };

  // const generateSignedUrlForVideo = async (bucket, key) => {
  //   try {
  //     if (!bucket || !key) return null;

  //     const idToken = sessionStorage.getItem("idToken");
  //     if (!idToken) throw new Error("No ID Token found in sessionStorage");

  //     const s3Client = new S3Client({
  //       region: process.env.REACT_APP_AWS_REGION,
  //       credentials: fromCognitoIdentityPool({
  //         clientConfig: { region: process.env.REACT_APP_AWS_REGION },
  //         identityPoolId: process.env.REACT_APP_IDENTITY_POOL_ID,
  //         logins: {
  //           [`cognito-idp.${process.env.REACT_APP_AWS_REGION}.amazonaws.com/${process.env.REACT_APP_USER_POOL_ID}`]:
  //             idToken,
  //         },
  //       }),
  //     });

  //     const command = new GetObjectCommand({ Bucket: bucket, Key: key });
  //     return await getSignedUrl(s3Client, command, { expiresIn: 3600 });
  //   } catch (error) {
  //     console.error("Error generating signed URL for thumbnail:", error);
  //     return null;
  //   }
  // };

  const fetchSignedVideoUrls = useCallback(
    async (segment) => {
      if (index < videos?.length) {
        try {
          let newUrl = await generateSignedUrlForVideos(
            segment?.video_s3_bucket,
            segment?.video_s3_key
          );
          setVideoUrls((prevUrls) => [...prevUrls, newUrl]);
        } catch (error) {
          console.error("Error fetching signed video URLs:", error);
        } finally {
          setIndex((prevIndex) => prevIndex + 1);
        }
      }
    },
    [index, videos]
  );
  const generateSignedUrlForVideos = async (bucket, key) => {
    try {
      if (!bucket || !key) return null;

      const idToken = sessionStorage.getItem("idToken");
      if (!idToken) throw new Error("No ID Token found in sessionStorage");

      const s3Client = new S3Client({
        region: process.env.REACT_APP_AWS_REGION,
        credentials: fromCognitoIdentityPool({
          clientConfig: { region: process.env.REACT_APP_AWS_REGION },
          identityPoolId: process.env.REACT_APP_IDENTITY_POOL_ID,
          logins: {
            [`cognito-idp.${process.env.REACT_APP_AWS_REGION}.amazonaws.com/${process.env.REACT_APP_USER_POOL_ID}`]:
              idToken,
          },
        }),
      });

      const command = new GetObjectCommand({ Bucket: bucket, Key: key });
      return await getSignedUrl(s3Client, command, { expiresIn: 3600 });
    } catch (error) {
      console.error("Error generating signed URL for thumbnail:", error);
      return null;
    }
  };

  useEffect(() => {
    if (props?.compilation?.length > 0) {
      if (index === null) setIndex(0);
      setVideos(props?.compilation);
      // fetchSignedThumbnailUrls(keySegments);
    } else {
      setVideos([]);
      setIndex(null);
    }
  }, [props?.compilation]);

  useEffect(() => {
    if (videos?.length > 0 && index !== null)
      fetchSignedVideoUrls(videos?.[index]);
  }, [index, videos]);

  useEffect(() => {
    setCurrentVideo(videos[currentIndex]);
    // console.log("current vid: ", videos[currentIndex]);
  }, [currentIndex]);

  useEffect(() => {
    setTheme(sessionStorage.getItem("mode"));
  }, [sessionStorage.getItem("mode"), theme]);

  useEffect(() => {
    if (videos?.length > 0) {
      let narrative = [];
      videos.forEach((video) => {
        let caption = sanitizeVideoCaption(
          video.video_caption || video.caption
        );
        let narrative_text = sanitizeVideoCaption(video.narrative_text);
        if (caption) {
          narrative.push(caption);
        } else {
          narrative.push(narrative_text);
        }
      });
      setNarrative(narrative);
    }
  }, [videos]);

  // Access currentStoryline from Redux to detect storyline changes
  const currentStoryline = useSelector(
    (state) => state.keysegmentsAndStorylines.currentStoryline
  );
  const [prevStorylineId, setPrevStorylineId] = useState(null);

  // useEffect(() => {
  //   setVideos(props?.compilation);
  //   if (props?.compilation?.length > 0) {
  //     fetchSignedVideoUrls(props?.compilation);
  //   } else {
  //     setVideos([]);
  //     setVideoUrls([]);
  //   }
  // }, [props?.compilation]);

  // Separate effect to handle storyline changes
  // useEffect(() => {
  //   // Only reset when currentStoryline changes and has a valid ID
  //   if (currentStoryline?.id && currentStoryline.id !== prevStorylineId) {
  //     setCurrentTime(0);
  //     setPlayedTime(0);
  //     setCurrentIndex(0);
  //     setPrevStorylineId(currentStoryline.id);
  //   }
  // }, [currentStoryline]);

  useEffect(() => {
    if (videos?.length === 0) setVideoUrls([]);
  }, [videos]);

  var playerref = React.createRef();

  return (
    <div style={{ flex: "auto" }}>
      {/* {props.agentText?.length > 0 && (
        <p
          style={{
            marginTop: 4,
            fontSize: 16,
            padding: "0 24px 0 0",
          }}
        >
          {props.isQA ? (
            <>
              <span style={{ fontWeight: 600, color: "#AC1FFF" }}>
                Answer:{" "}
              </span>{" "}
              {props.answerText}
            </>
          ) : (
            <>{props.agentText}</>
          )}
        </p>
      )}
        */}

      {/* <code className="progress">
        {props.isQA ? "" : props.message}
        {props.isQA && props.message !== "Curation complete"
          ? "Curating answer"
          : ""}
        {props.message !== "Curation complete" && !props.isHistory && (
          <CircularProgress
            size={18}
            thickness={8}
            sx={{
              marginLeft: "12px",
              verticalAlign: "middle",
              color: "#AC1FFF",
            }}
          />
        )}
      </code> */}
      {props?.isQA && (
        <Box mb={'0.5rem'}>
          {/* <span style={{ fontWeight: 600, color: '#AC1FFF' }}>Question: </span> {queryTextRedux}
          <br /> */}
          <span style={{ fontWeight: 600, color: '#AC1FFF' }}>Answer: </span> {props.answerText}
        </Box>
      )}
      {!props?.isQA && props.socketComplete && videos.length < 1 && (
        <Alert
          className="flex-center-center"
          variant="text"
          severity="error"
          sx={{ borderRadius: 48 }}
        >
          {/* No Video Stories were found. Please try a different query. */}
          {props?.agentText ? props?.agentText : "No results were found. Please try a different query."}
        </Alert>
      )}

      {videos.length > 0 && (
        <Grid container spacing={5}>
          <Grid item xs={12} sm={12}>
            <Box
              sx={{
                width: "85%",
                height: "20%",
                margin: "auto",
              }}
            >
              <div className={wrapperClassName} ref={ref}>
                {/* {currentIndex + 1 < videos.length && ( */}
                {false && (
                  <>
                    <video
                      key={currentIndex}
                      src={`${
                        videos[currentIndex]["video_s3_presigned_url"]
                      }#t=${
                        parseFloat(videos[currentIndex].video_start_time) / 1000
                      },${
                        parseFloat(videos[currentIndex].video_end_time) / 1000
                      }`}
                      style={{ display: "none" }}
                      preload="auto"
                    />
                    <video
                      key={currentIndex + 1}
                      src={`${
                        videos[currentIndex + 1]["video_s3_presigned_url"]
                      }#t=${
                        parseFloat(videos[currentIndex + 1].video_start_time) /
                        1000
                      },${
                        parseFloat(videos[currentIndex + 1].video_end_time) /
                        1000
                      }`}
                      style={{ display: "none" }}
                      preload="auto"
                    />
                  </>
                )}
                <ReactPlayer
                  ref={playerref}
                  controls={false}
                  muted={mute}
                  playing={inView ? playing : false} // {playing}
                  className={`${playerClassName}`}
                  // url={
                  //   currentIndex < videos.length && videos.length > 0
                  //     ? `${videos[currentIndex]["video_s3_presigned_url"]}#t=${
                  //         parseFloat(videos[currentIndex]?.video_start_time) /
                  //         1000
                  //       },${
                  //         parseFloat(videos[currentIndex]?.video_end_time) / 1000
                  //       }`
                  //     : null
                  // }
                  url={`${videoUrls[currentIndex]}#t=${
                    parseFloat(videos[currentIndex]?.video_start_time) / 1000
                  },${parseFloat(videos[currentIndex]?.video_end_time) / 1000}`}
                  width="100%"
                  height="100%"
                  progressInterval={500}
                  onProgress={(prog) => {
                    for (var i = 0; i < currentIndex; i++) {
                      timeSoFar +=
                        parseFloat(
                          videos[i]["video_end_time"] -
                            videos[i]["video_start_time"]
                        ) / 1000;
                    }

                    setCurrentTime(
                      timeSoFar +
                        prog.playedSeconds -
                        videos[currentIndex]?.["video_start_time"] / 1000
                    );

                    setPlayedTime(prog.playedSeconds);

                    let firstSecond =
                      prog.playedSeconds -
                      videos[currentIndex]["video_start_time"] / 1000;
                    let lastSecond =
                      videos[currentIndex]["video_end_time"] / 1000 -
                      prog.playedSeconds;

                    if (firstSecond < 1.25 && firstSecond >= 0) {
                      setWrapperClassName("player-wrapper fade-in");
                    } else if (lastSecond < 0.5) {
                      setWrapperClassName("player-wrapper fade-out");
                    } else {
                      setWrapperClassName("player-wrapper");
                    }
                    if (
                      prog.playedSeconds >=
                        parseFloat(
                          videos[currentIndex]["video_end_time"] / 1000
                        ) &&
                      currentIndex < videos.length
                    ) {
                      nextVideo();
                    }
                  }}
                />

                {/* { playing && */}
                <div
                  className={`video_timestamp ${
                    videoTimeStampLocation === "right"
                      ? "align-right"
                      : "align-left"
                  }`}
                >
                  <CalendarMonthIcon
                    style={{
                      marginRight: 4,
                      fontSize: 18,
                      filter: "drop-shadow( 0 0 5px rgba(0, 0, 0, 1))",
                    }}
                  />
                  {videos[currentIndex]?.first_pub_date ||
                    moment(
                      videos?.[currentIndex]?.["video_timestamp"]?.[
                        "epoch_millis"
                      ]
                    ).format("MMMM DD, YYYY")}
                  {/* {videos[currentIndex]?.program_name !== "" && (
                  <>
                    <LocationOnOutlined
                      style={{ marginRight: 4, marginLeft: 24, fontSize: 18 }}
                    />
                    {videos[currentIndex].program_name ||
                      videos[currentIndex]["location"]}
                  </>
                )} */}
                </div>
                {/* } */}

                {/* { ((Math.round(currentTime) % 60) > 0) &&
                <div className={`caption_text has-captions-${videos[currentIndex]['timed_captions'].length > 0 && captions}`}>
                  {videos[currentIndex]?.caption || videos[currentIndex]?.narrative_text}
                </div>
              } */}

                {/* { captions && videos[currentIndex]['timed_captions'].map((caption, index) =>
                  ((parseFloat(caption['end_time'])/1000) >= playedTime) && ((parseFloat(caption['start_time'])/1000) <= playedTime) &&
                  <div className='video_annotation'>
                    <div className="video_cc">
                    {caption['text']}
                    </div>
                  </div>
              )} */}
              </div>

              <Box display="flex" py={1} className="video_playback">
                {playing && inView ? (
                  <PauseCircleOutlineIcon
                    style={{
                      fontSize: 36,
                      marginRight: "12px",
                      cursor: "pointer",
                    }}
                    onClick={playPauseHandler}
                  />
                ) : (
                  <PlayCircleOutlineIcon
                    style={{
                      fontSize: 36,
                      marginRight: "12px",
                      cursor: "pointer",
                    }}
                    onClick={playPauseHandler}
                  />
                )}
                <div style={{ flex: 1 }}>
                  <div style={{ display: "flex", marginTop: 4 }}>
                    {videos.length > 0 &&
                      videos.map((video, index) => (
                        <Tooltip
                          key={videos[index].id}
                          componentsProps={{
                            tooltip: {
                              sx: {
                                background: "#ffffff",
                                color: "#666666",
                                boxShadow: "0 0 8px rgba(0,0,0,0.35)",
                                padding: 1,
                                borderRadius: 4,
                              },
                            },
                          }}
                          title={
                            <React.Fragment>
                              Duration:{" "}
                              {videos[index]["clip_duration"]
                                ? Math.round(videos[index]["clip_duration"]) +
                                  " seconds"
                                : Math.round(
                                    videos[index]["video_duration"] / 1000
                                  ) + " seconds"}
                              <br />
                              {videos[index].thumbnail_s3_presigned_url && (
                                <img
                                  src={videos[index].thumbnail_s3_presigned_url}
                                  style={{
                                    marginBottom: "6px",
                                    borderRadius: "8px",
                                  }}
                                  width="100%"
                                  alt={
                                    videos[index].caption ||
                                    videos[index].narrative_text
                                  }
                                />
                              )}
                              {/* <div style={{ padding: "4px" }}>
                                {videos[index].caption ||
                                  videos[index].narrative_text}
                              </div> */}
                            </React.Fragment>
                          }
                        >
                          <div
                            key={index}
                            className={
                              "videoPager videoPager-" +
                              index +
                              (index === currentIndex ? " isActive" : "") +
                              " " +
                              sessionStorage.getItem("mode")
                            }
                            onClick={() => handlePager(index)}
                            style={{
                              flex: "1 1 0px",
                              height: "8px",
                            }}
                          />
                        </Tooltip>
                      ))}
                  </div>
                  <Slider
                    sx={{
                      padding: 0,
                      "&.MuiSlider-root": {
                        padding: 0,
                      },
                      "& .MuiSlider-thumb": {
                        backgroundColor: "#e70088",
                        width: 0,
                      },
                      "& .MuiSlider-rail": {
                        backgroundColor: "#cccccc",
                      },
                      "& .MuiSlider-track": {
                        backgroundColor: "#e70088",
                        border: 0,
                      },
                      "& .MuiSlider-mark": {
                        backgroundColor: "#AC1FFF",
                        height: 8,
                      },
                      "& .MuiSlider-thumb": {
                        height: 2,
                        width: 2,
                      },
                    }}
                    disabled
                    marks={marks}
                    // valueLabelDisplay='auto'
                    // onChange={handleScrubChange}
                    value={(currentTime / getCompilationDuration) * 100}
                  />
                </div>

                <Box px={2} sx={{ fontSize: 10, fontFamily: "monospace" }}>
                  {Math.floor(currentTime / 60) > 9
                    ? Math.floor(currentTime / 60)
                    : "0" + Math.floor(currentTime / 60)}
                  :
                  {Math.round(currentTime) % 60 > 9
                    ? Math.round(currentTime) % 60
                    : "0" + (Math.round(currentTime) % 60)}
                  /
                  {Math.floor(getCompilationDuration / 60) > 9
                    ? Math.floor(getCompilationDuration / 60)
                    : "0" + Math.floor(getCompilationDuration / 60)}
                  :
                  {Math.round(getCompilationDuration) % 60 > 9
                    ? Math.round(getCompilationDuration) % 60
                    : "0" + (Math.round(getCompilationDuration) % 60)}
                </Box>
                {mute ? (
                  <VolumeOffOutlinedIcon
                    onClick={muteHandler}
                    style={{ cursor: "pointer", fill: "#AC1FFF" }}
                  />
                ) : (
                  <VolumeMuteOutlinedIcon
                    onClick={muteHandler}
                    style={{ cursor: "pointer" }}
                  />
                )}
                {captions || fullNarrative ? (
                  <SubtitlesIcon
                    onClick={toggleFullNarrative}
                    style={{
                      cursor: "pointer",
                      marginLeft: 4,
                      fill: "#AC1FFF",
                    }}
                  />
                ) : (
                  <SubtitlesOffIcon
                    onClick={toggleFullNarrative}
                    style={{ cursor: "pointer", marginLeft: 4 }}
                  />
                )}
                <CameraRollIcon
                  style={{ cursor: "pointer", marginLeft: 8 }}
                  onClick={altClipsClickHandler}
                />
                {/* {devToolAccess == "true" ? (
                <ManageSearchIcon
                  style={{ cursor: "pointer", marginLeft: 12 }}
                  onClick={debugClickHandler}
                />
              ) : null} */}
              </Box>
            </Box>
          </Grid>
          <Grid item xs={12} sm={12}>
            {props.storyMetadata && (
              <div className="story_metadata">
                {!captions &&
                  window.innerWidth < 600 &&
                  videos[currentIndex]?.caption &&
                  soundbite_text(videos[currentIndex].description) ===
                    "true" && (
                    <div className="video_annotation">
                      <div className="video_cc">
                        {videos[currentIndex]?.caption}
                      </div>
                    </div>
                  )}

                {!captions &&
                  window.innerWidth < 600 &&
                  videos[currentIndex]?.caption &&
                  soundbite_text(videos[currentIndex].description).length ===
                    3 && (
                    <div className="video_annotation">
                      <div className="video_cc">
                        {soundbite_text(videos[currentIndex].description)[2]}
                      </div>
                    </div>
                  )}

                {captions &&
                  window.innerWidth < 600 &&
                  videos[currentIndex]["timed_captions"].map(
                    (caption, index) =>
                      parseFloat(caption["end_time"]) / 1000 >= playedTime &&
                      parseFloat(caption["start_time"]) / 1000 <=
                        playedTime && (
                        <div className="video_annotation">
                          <div className="video_cc">{caption["text"]}</div>
                        </div>
                      )
                  )}

                {props?.isQA ? null : (
                  <h6 onClick={toggleFullNarrative}>
                    {props.storyMetadata["title"]
                      ? props.storyMetadata["title"]
                      : "Reference Videos"}
                    {fullNarrative ? (
                      <ExpandLessOutlinedIcon
                        style={{
                          fontSize: 18,
                          marginLeft: 16,
                          alignItems: "center",
                          borderRadius: 50,
                          border: "1px solid",
                        }}
                      />
                    ) : (
                      <ExpandMoreOutlinedIcon
                        style={{
                          fontSize: 18,
                          marginLeft: 16,
                          borderRadius: 50,
                          border: "1px solid",
                          alignItems: "center",
                        }}
                      />
                    )}
                  </h6>
                )}
                {fullNarrative ? (
                  <div className="narrative-container">
                    {props?.isQA ? (
                      <ul className="narrative-list">
                        {narrative.map((item, index) => (
                          <li
                            className={
                              currentIndex == index
                                ? "list-item-active"
                                : "list-item"
                            }
                            style={{
                              color: mode === "dark" ? "#ffffff" : "#000000",
                            }}
                          >
                            {item}
                          </li>
                        ))}
                      </ul>
                    ) : (
                      <>
                        {currentIndex > 0 && (
                          <span
                            style={{
                              // color: "#666666",
                              marginRight: "4px",
                            }}
                          >
                            {narrative.slice(0, currentIndex).join(" ")}
                          </span>
                        )}
                        <span
                          style={{
                            // color: "#666666",
                            fontWeight: "800",
                            marginRight: "4px",
                          }}
                        >
                          {narrative.slice(currentIndex, currentIndex + 1)}
                        </span>
                        <span
                          style={{
                            // color: "#666666",
                            marginRight: "4px",
                          }}
                        >
                          {narrative.slice(currentIndex + 1).join(" ")}
                        </span>
                      </>
                    )}{" "}
                  </div>
                ) : (
                  <div
                    style={{
                      marginRight: "4px",
                      fontSize: "14px",
                      lineHeight: "21px",
                    }}
                  >
                    {narrative.slice(currentIndex, currentIndex + 1)}
                  </div>
                )}
                {/* <p>{videos[currentIndex].caption}</p> */}
              </div>
            )}{" "}
          </Grid>
        </Grid>
      )}

      {props?.isCurationCancelled && videos.length < 1 && (
        <h5 style={{ textAlign: "center" }}>Query Canceled</h5>
      )}
      {!props?.isCurationCancelled &&
        videos.length < 1 &&
        !props.socketComplete &&
        (props.message !== "Curation complete" ||
          props.agentText !==
            "Something went wrong. Please try again soon.") && <LoaderVideo />}
    </div>
  );
}
